import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=b64488a4&scoped=true&"
import script from "./channelList.vue?vue&type=script&lang=js&"
export * from "./channelList.vue?vue&type=script&lang=js&"
import style0 from "./channelList.vue?vue&type=style&index=0&id=b64488a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64488a4",
  null
  
)

export default component.exports